import React, { useState } from "react";
import { setTitle } from "../../../helpers/MetaTag";
import OrderListing from "../../../components/sections/front/User/OrderListing";
import ProfileStatistics from "../../../components/sections/front/User/ProfileStatistics";
import CurrentSubscription from "../../../components/sections/front/User/CurrentSubscription";
import CurrentAddress from "../../../components/sections/front/User/CurrentAddress";
import Image01 from "../../../assets/images/image-01.webp";
import Image02 from "../../../assets/images/image-02.webp";
import Image03 from "../../../assets/images/image-03.webp";
import Image04 from "../../../assets/images/image-04.webp";
import Image05 from "../../../assets/images/image-05.webp";
import Image06 from "../../../assets/images/image-06.webp";
import Image07 from "../../../assets/images/image-07.webp";
import Image08 from "../../../assets/images/image-08.webp";
import Image09 from "../../../assets/images/image-09.webp";
import Image10 from "../../../assets/images/image-10.webp";
import useFetch from "../../../hooks/useFetch";
import { orderList } from "../../../services/orderService";
import { useDebounce } from "../../../hooks/useDebounce";
import dayjs from "dayjs";

const Orders = () => {
  setTitle("Memory Doddle | Orders");
  const [filters, setFilters] = useState({
    limit: 1000,
    page: 1,
  });
  const [status, setStatus] = useState("All");
  const [deliveryStatus, setDeliveryStatus] = useState("All");
  const [sort, setSort] = useState("-createdAt");
  const [keyword, setKeyword] = useState("");
  const [filterOn, setFilterOn] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  // const search = useDebounce(keyword, 500);
  const {
    data: orders,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["orders", filters, keyword, sort, dateRange, status],
    fetchFunction: async () => {
      const res = await orderList({
        ...filters,
        ...(filterOn && keyword && { keyword }),
        ...(filterOn && sort && { sortQuery: sort }),
        ...(filterOn &&
          dateRange?.startDate && {
            startDate: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
          }),
        ...(filterOn &&
          dateRange?.endDate && {
            endDate: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
          }),
        ...(filterOn && status && status !== "All" && { status }),
      });
      return res?.docs;
    },
  });

  // const orders = [
  //   {
  //     _id: 1,
  //     name: "Envato's catalogue",
  //     description: "Explore Envato's catalogue of profile dashboard templates...",
  //     orderid: "ORD0079246",
  //     transactionid: "TXN0095862",
  //     status: "Awaiting",
  //     deliverystatus: "Awaiting",
  //     orderdate: "30 May, 2025",
  //     deliverydate: "6 June, 2025",
  //     link: "/order/ORD0079246",
  //     file: [
  //       { filename: "order_001.png", image: Image01 },
  //       { filename: "order_002.png", image: Image02 },
  //       { filename: "order_003.png", image: Image03 },
  //       { filename: "order_004.png", image: Image04 },
  //       { filename: "order_005.png", image: Image05 },
  //       { filename: "order_006.png", image: Image06 },
  //       { filename: "order_007.png", image: Image07 },
  //       { filename: "order_008.png", image: Image08 },
  //       { filename: "order_009.png", image: Image09 },
  //       { filename: "order_001.png", image: Image10 },
  //     ],
  //   },
  //   {
  //     _id: 2,
  //     name: "Creative Market Order",
  //     description: "Discover Creative Market’s best-selling design assets for UI/UX projects.",
  //     orderid: "ORD0079247",
  //     transactionid: "TXN0095863",
  //     status: "Approved",
  //     deliverystatus: "Delivered",
  //     orderdate: "29 May, 2025",
  //     deliverydate: "5 June, 2025",
  //     link: "/order/ORD0079247",
  //     file: [
  //       { filename: "order_001.png", image: Image01 },
  //       { filename: "order_002.png", image: Image02 },
  //       { filename: "order_003.png", image: Image03 },
  //       { filename: "order_004.png", image: Image04 },
  //       { filename: "order_005.png", image: Image05 },
  //       { filename: "order_006.png", image: Image06 },
  //       { filename: "order_007.png", image: Image07 },
  //       { filename: "order_008.png", image: Image08 },
  //       { filename: "order_009.png", image: Image09 },
  //       { filename: "order_001.png", image: Image10 },
  //     ],
  //   },
  //   {
  //     _id: 3,
  //     name: "Figma Plugin Purchase",
  //     description: "Purchased a premium set of Figma plugins for faster design iteration.",
  //     orderid: "ORD0079248",
  //     transactionid: "TXN0095864",
  //     status: "Fullfilled",
  //     deliverystatus: "Delivered",
  //     orderdate: "28 May, 2025",
  //     deliverydate: "—",
  //     link: "/order/ORD0079248",
  //     file: [
  //       { filename: "order_001.png", image: Image01 },
  //       { filename: "order_002.png", image: Image02 },
  //       { filename: "order_003.png", image: Image03 },
  //       { filename: "order_004.png", image: Image04 },
  //       { filename: "order_005.png", image: Image05 },
  //       { filename: "order_006.png", image: Image06 },
  //       { filename: "order_007.png", image: Image07 },
  //       { filename: "order_008.png", image: Image08 },
  //       { filename: "order_009.png", image: Image09 },
  //       { filename: "order_001.png", image: Image10 },
  //     ],
  //   },
  //   {
  //     _id: 4,
  //     name: "UI8 Interface Kit",
  //     description: "Get access to a comprehensive design system from UI8’s latest release.",
  //     orderid: "ORD0079249",
  //     transactionid: "TXN0095865",
  //     status: "Declined",
  //     deliverystatus: "Cancelled",
  //     orderdate: "27 May, 2025",
  //     deliverydate: "3 June, 2025",
  //     link: "/order/ORD0079249",
  //     file: [
  //       { filename: "order_001.png", image: Image01 },
  //       { filename: "order_002.png", image: Image02 },
  //       { filename: "order_003.png", image: Image03 },
  //       { filename: "order_004.png", image: Image04 },
  //       { filename: "order_005.png", image: Image05 },
  //       { filename: "order_006.png", image: Image06 },
  //       { filename: "order_007.png", image: Image07 },
  //       { filename: "order_008.png", image: Image08 },
  //       { filename: "order_009.png", image: Image09 },
  //       { filename: "order_001.png", image: Image10 },
  //     ],
  //   },
  //   {
  //     _id: 5,
  //     name: "Adobe Stock Assets",
  //     description: "A curated batch of high-resolution stock graphics from Adobe.",
  //     orderid: "ORD0079250",
  //     transactionid: "TXN0095866",
  //     status: "Cancelled",
  //     deliverystatus: "Cancelled",
  //     orderdate: "26 May, 2025",
  //     deliverydate: "2 June, 2025",
  //     link: "/order/ORD0079250",
  //     file: [
  //       { filename: "order_001.png", image: Image01 },
  //       { filename: "order_002.png", image: Image02 },
  //       { filename: "order_003.png", image: Image03 },
  //       { filename: "order_004.png", image: Image04 },
  //       { filename: "order_005.png", image: Image05 },
  //       { filename: "order_006.png", image: Image06 },
  //       { filename: "order_007.png", image: Image07 },
  //       { filename: "order_008.png", image: Image08 },
  //       { filename: "order_009.png", image: Image09 },
  //       { filename: "order_001.png", image: Image10 },
  //     ],
  //   },
  //   {
  //     _id: 6,
  //     name: "Dribbble Shots Pack",
  //     description: "Dribbble premium shots pack with trendy UI/UX elements.",
  //     orderid: "ORD0079251",
  //     transactionid: "TXN0095867",
  //     status: "Awaiting",
  //     deliverystatus: "Awaiting",
  //     orderdate: "25 May, 2025",
  //     deliverydate: "1 June, 2025",
  //     link: "/order/ORD0079251",
  //     file: [
  //       { filename: "order_001.png", image: Image01 },
  //       { filename: "order_002.png", image: Image02 },
  //       { filename: "order_003.png", image: Image03 },
  //       { filename: "order_004.png", image: Image04 },
  //       { filename: "order_005.png", image: Image05 },
  //       { filename: "order_006.png", image: Image06 },
  //       { filename: "order_007.png", image: Image07 },
  //       { filename: "order_008.png", image: Image08 },
  //       { filename: "order_009.png", image: Image09 },
  //       { filename: "order_001.png", image: Image10 },
  //     ],
  //   },
  //   {
  //     _id: 7,
  //     name: "ThemeForest Bundle",
  //     description: "Downloaded a bundle of multipurpose WordPress themes from ThemeForest.",
  //     orderid: "ORD0079252",
  //     transactionid: "TXN0095868",
  //     status: "Approved",
  //     deliverystatus: "Cancelled",
  //     orderdate: "24 May, 2025",
  //     deliverydate: "31 May, 2025",
  //     link: "/order/ORD0079252",
  //     file: [
  //       { filename: "order_001.png", image: Image01 },
  //       { filename: "order_002.png", image: Image02 },
  //       { filename: "order_003.png", image: Image03 },
  //       { filename: "order_004.png", image: Image04 },
  //       { filename: "order_005.png", image: Image05 },
  //       { filename: "order_006.png", image: Image06 },
  //       { filename: "order_007.png", image: Image07 },
  //       { filename: "order_008.png", image: Image08 },
  //       { filename: "order_009.png", image: Image09 },
  //       { filename: "order_001.png", image: Image10 },
  //     ],
  //   },
  //   {
  //     _id: 8,
  //     name: "Bootstrap UI Kit",
  //     description: "Bootstrap 5 compatible UI kit with hundreds of components.",
  //     orderid: "ORD0079253",
  //     transactionid: "TXN0095869",
  //     status: "Fullfilled",
  //     deliverystatus: "Delivered",
  //     orderdate: "23 May, 2025",
  //     deliverydate: "30 May, 2025",
  //     link: "/order/ORD0079253",
  //     file: [
  //       { filename: "order_001.png", image: Image01 },
  //       { filename: "order_002.png", image: Image02 },
  //       { filename: "order_003.png", image: Image03 },
  //       { filename: "order_004.png", image: Image04 },
  //       { filename: "order_005.png", image: Image05 },
  //       { filename: "order_006.png", image: Image06 },
  //       { filename: "order_007.png", image: Image07 },
  //       { filename: "order_008.png", image: Image08 },
  //       { filename: "order_009.png", image: Image09 },
  //       { filename: "order_001.png", image: Image10 },
  //     ],
  //   },
  //   {
  //     _id: 9,
  //     name: "Notion Dashboard Template",
  //     description: "Ordered a customizable Notion template for productivity workflows.",
  //     orderid: "ORD0079254",
  //     transactionid: "TXN0095870",
  //     status: "Declined",
  //     deliverystatus: "Cancelled",
  //     orderdate: "22 May, 2025",
  //     deliverydate: "29 May, 2025",
  //     link: "/order/ORD0079254",
  //     file: [
  //       { filename: "order_001.png", image: Image01 },
  //       { filename: "order_002.png", image: Image02 },
  //       { filename: "order_003.png", image: Image03 },
  //       { filename: "order_004.png", image: Image04 },
  //       { filename: "order_005.png", image: Image05 },
  //       { filename: "order_006.png", image: Image06 },
  //       { filename: "order_007.png", image: Image07 },
  //       { filename: "order_008.png", image: Image08 },
  //       { filename: "order_009.png", image: Image09 },
  //       { filename: "order_001.png", image: Image10 },
  //     ],
  //   },
  //   {
  //     _id: 10,
  //     name: "Webflow Landing Pages",
  //     description: "Responsive Webflow templates for modern product landing pages.",
  //     orderid: "ORD0079255",
  //     transactionid: "TXN0095871",
  //     status: "Cancelled",
  //     deliverystatus: "Cancelled",
  //     orderdate: "21 May, 2025",
  //     deliverydate: "28 May, 2025",
  //     link: "/order/ORD0079255",
  //     file: [
  //       { filename: "order_001.png", image: Image01 },
  //       { filename: "order_002.png", image: Image02 },
  //       { filename: "order_003.png", image: Image03 },
  //       { filename: "order_004.png", image: Image04 },
  //       { filename: "order_005.png", image: Image05 },
  //       { filename: "order_006.png", image: Image06 },
  //       { filename: "order_007.png", image: Image07 },
  //       { filename: "order_008.png", image: Image08 },
  //       { filename: "order_009.png", image: Image09 },
  //       { filename: "order_001.png", image: Image10 },
  //     ],
  //   },
  // ];

  return (
    <>
      <div className="relative space-y-5">
        <div className="grid grid-cols-3 gap-4 3xl:gap-6 items-start">
          <div className="relative col-span-2">
            <OrderListing
              title={"My Coloring Books"}
              data={orders}
              isSort={true}
              isfilter={true}
              sort={sort}
              filters={filters}
              keyword={keyword}
              dateRange={dateRange}
              status={status}
              filterOn={filterOn}
              setFilterOn={setFilterOn}
              setSort={setSort}
              setFilters={setFilters}
              setKeyword={setKeyword}
              setDateRange={setDateRange}
              setStatus={setStatus}
              isLoading={isLoading}
            />
          </div>
          <div className="relative grid grid-cols-1 gap-4">
            <ProfileStatistics />
            <CurrentSubscription />
            <CurrentAddress />
          </div>
        </div>
      </div>
    </>
  );
};

export default Orders;
